import { useState } from "react";
import Loader from "../Loader";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getLogged } from "../../redux/userSlice";
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';

const LoginForm = ({ setSection }) => {
    const { t } = useTranslation();
    const [inputData, setInputData] = useState({
        email: '',
        password: ''
    })
    const handleInputData = (event) => {
        const { id, value } = event.target;
        setInputData(prevState => ({
            ...prevState,
            [id]: value
        })
        )
    }
    const [fetchStatus, setFetchStatus] = useState('idle');
    const [error, setError] = useState(null);

    // Send login fetch
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const sendLoginData = async () => {
        try {
            setFetchStatus('loading');
            const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/login`;
            const headers = { 'Content-Type': 'application/json' };
            const options = { method: 'POST', headers, body: JSON.stringify(inputData) }
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                console.log('Login fetch result: ', result);
                setFetchStatus('succeeded');
                localStorage.setItem('ticino-wild-token', result.payload.token);
                dispatch(getLogged(result.payload));
                setTimeout(() => {
                    navigate("/")
                }, 3000);
            } else {
                const error = await response.json();
                console.log('Fetch error: ', error);
                setFetchStatus('failed');
                setError(error.message);
            }
        } catch (error) {
            console.log('Catch error: ', error);
            setFetchStatus('failed');
            setError(error.message);
        }
    }

    // Handle password show
    const [isShowPassword, setIsShowPassword] = useState(false);
    return (
        <div className="w-full lg:h-[800px] flex flex-col items-center gap-2">
            {
                fetchStatus === 'idle' &&
                <div className="flex flex-col items-center gap-2 w-full">
                    <label htmlFor="email">{t('RegisterLoginPage.LoginForm.email')}:</label>
                    <input type="text" id="email" className="w-full md:w-96" onChange={handleInputData} value={inputData.email} placeholder="La tua email" />
                </div>
            }
            {
                fetchStatus === 'idle' &&
                <div className="flex flex-col items-center gap-2 w-full mb-8">
                    <label htmlFor="password">{t('RegisterLoginPage.LoginForm.password')}:</label>
                    <div className="w-full md:w-fit flex items-center gap-2">
                        <input type={isShowPassword ? "text" : "password"} id="password" className="w-full md:w-96" onChange={handleInputData} value={inputData.password} />
                        {
                            isShowPassword ?
                                (
                                    <EyeOff className="cursor-pointer" onClick={() => setIsShowPassword(false)} />
                                ) : (
                                    <Eye className="cursor-pointer" onClick={() => setIsShowPassword(true)} />
                                )
                        }
                    </div>
                </div>
            }
            {
                fetchStatus === 'idle' &&
                <Link to="/reset-password" tabIndex="-1"><h5 className="md:ml-[-130px] mt-[-30px] mb-8 underline">{t('RegisterLoginPage.LoginForm.forgotPassword')}</h5></Link>
            }
            {
                fetchStatus === 'idle' && inputData.email && inputData.password &&
                <button className="green-button w-full md:w-fit" onClick={sendLoginData}>Login</button>
            }
            {
                fetchStatus === 'idle' && (!inputData.email || !inputData.password) &&
                <button className="green-button-disabled w-full md:w-fit" >{t('RegisterLoginPage.LoginForm.loginButton')}</button>
            }
            {
                fetchStatus === 'idle' &&
                <h5 className="mt-8 cursor-pointer underline" onClick={() => setSection('Register')}>{t('RegisterLoginPage.LoginForm.notHaveAccount')}</h5>
            }
            {
                fetchStatus === 'loading' &&
                <Loader />
            }
            {
                fetchStatus === 'succeeded' &&
                <h3 className="text-center">{t('RegisterLoginPage.LoginForm.loginSucceeded')}</h3>
            }
            {
                fetchStatus === 'failed' && error &&
                <div className="flex flex-col items-center">
                    <h3>{t('RegisterLoginPage.LoginForm.loginFailed')}</h3>
                    {<h5>{error}</h5>}
                </div>
            }

        </div>
    )
}

export default LoginForm;